<template>
    <div>
        <CommonSpinner v-if="isLoading" />
        <div v-else class="row">
            <div v-if="item" class="col-12">
                <div class="row g-3 mb-5">
                    <div class="col-lg-8">
                        <opportunity-detail-card :item="item" />
                        <aksu-requirement-card 
                            v-if="!item.opportunity_match && item.category_id == 66"
                            class="mt-4"/>
                    </div>
                    <div class="col-md-4 order-md-2">
                        <div class="position-sticky" style="top: 90px;">
                            <div v-if="item.opportunity_match" >
                                <application-success-card :item="item.opportunity_match" />
                            </div>
                            <div v-else class="bd-callout mt-0 mb-0 bd-callout-warning">
                                <h4>Quick and Easy Application Process </h4>
                                <div class="pt-4">
                                    <p class="mb-1">
                                        Applying is simple! After reviewing the job description and ensuring you meet
                                        the eligibility criteria, simply click the button below to submit your
                                        application for this opportunity.
                                    </p>
                                    <div class="d-grid pt-4">
                                        <router-link :to="`/open-opportunities/${item.id}/apply`" class="btn btn-primary" >Apply Now</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import OpportunityDetailCard from '@/components/cards/OpportunityDetailCard.vue'
import AksuRequirementCard from '@/components/cards/AksuRequirementCard.vue';
import ApplicationSuccessCard from '@/components/cards/ApplicationSuccessCard.vue';

export default {
    name: "opportunity-show",
    components: {
        OpportunityDetailCard,
        AksuRequirementCard,
        ApplicationSuccessCard
    },
    data() {
        return {
            isLoading: false,
            item: null,
        }
    },
    computed: {
        activeUser() {
            return this.$store.state.AppActiveUser
        },
    },
    methods: {
        updateItem(item) {
            Object.assign(this.item, item);
        },
        async fetchItem(showLoader = true) {
            this.isLoading = showLoader;
            this.$http.get(`/opportunities/${this.$route.params.opportunityId}/show`)
                .then((response) => {
                    this.isLoading = false
                    if (response.data.success) {
                        this.item = response.data.data
                    } else {
                        this.$router.push({ path: '/error-404' })
                    }
                })
        },
        initializeAll() {
            this.popupModalApply = false
        }
    },
    created() {
        this.fetchItem()
    }
}

</script>
<style scoped>
.user-photo {
    width: 10rem;
}

.circles-container {
    position: absolute;
    bottom: 0;
    top: 0;
    width: 20%;
    right: -20%;
}

.circle-back,
.circle-front {
    background-color: #e1f6e2;
    position: relative;
    width: 200%;
    padding-top: 200%;
    padding-bottom: 0;
    border-radius: 100%;
    display: inline-block
}

.circle-back {
    opacity: .6;
    z-index: 3;
    margin-left: -108%;
    margin-top: 0
}

.circle-front {
    opacity: .5;
    margin-bottom: 50%;
    margin-left: -209%;
    z-index: 4
}
</style>
